import urlUtil from './url';

export default function isFeedsFast() {
  try {
    if (typeof window !== 'undefined') {
      const urlObj = urlUtil.parse(window.location.href);
      return (urlObj && urlObj.query && urlObj.query.FV && parseInt(urlObj.query.FV, 10) === 1) || false;
    }
  } catch (e) {
    console.log('isFeedsFast e=', e);
    return false;
  }
}
